import React, { useState } from 'react'
import { IconMaps } from '@ow/icons'
import { Button } from '@ow/comps'
import styled from '@emotion/styled'
import { pick } from 'lodash-es'
import { showNotification } from '@mantine/notifications'
import {
  useAppEx,
  useDetailStore,
  useProcessStore,
  useTbViewStore,
} from '@vt/hooks'
import FaceRecognition from '../../face-recognition'

const StyledBtnContent = styled.div`
  padding: 24px;
  display: flex;
  justify-content: flex-end;
  button + button {
    margin-left: 15px;
  }
`
const StyledStatusContent = styled.div`
  padding: 24px;
  border-top: 1px solid #e7e7e7;
  display: flex;
  align-items: center;
  span {
    font-weight: 500;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.9);
    margin-left: 12px;
  }
`

const Content = function ({ setShowContent, setDataById }) {
  const [startFlowLoading, setStartFlowLoading] = useState(false)
  const { userInfoInApp } = useAppEx()
  const { setRefreshLog } = useDetailStore((state) =>
    pick(state, ['setRefreshLog'])
  )
  const { setRefreshStatus, fetchTbData, detailConfig } = useTbViewStore(
    (state) => pick(state, ['setRefreshStatus', 'fetchTbData', 'detailConfig'])
  )
  const {
    updateStageNode,
    setCurrentNode,
    data,
    processNodes,
    setProcessNodes,
    setIsRefreshNode,
    isShowStartFlow,
    startFlow,
    setShowStartFlow,
  } = useProcessStore((state) =>
    pick(state, [
      'updateStageNode',
      'setCurrentNode',
      'data',
      'processNodes',
      'setProcessNodes',
      'setIsRefreshNode',
      'isShowStartFlow',
      'startFlow',
      'setShowStartFlow',
    ])
  )
  // 视图中是否配置了允许开启流程
  const allowStartFlow =
    detailConfig && detailConfig.allowFlow && detailConfig.allowFlow.allowStart

  // 1. 没有操作节点 or 2. 有操作节点&&操作节点enableLevelControl为true&&当前案件等级!==用户组织等级
  const isShowStatus =
    !processNodes.length ||
    (processNodes.length &&
      processNodes[0].enableLevelControl &&
      data.shouldProcessingDepartmentLevel !== userInfoInApp.orgLevel)

  /**
   * 更新loading效果
   * @param {number} index 需要处理的下标
   * @param {boolean} flag 需要将指定元素loading改为true/false
   * @returns
   */
  const updLoading = (index, flag) => {
    return processNodes.map((item, idx) => {
      return { ...item, loading: idx === index ? flag : false }
    })
  }
  const submitNode = (node, index) => {
    setCurrentNode(node)
    if (node.needForm) {
      // 需要显示新的表单内容
      setShowContent('form')
    } else {
      // 不显示新的表单内容，直接请求操作节点接口
      setProcessNodes(updLoading(index, true))
      updateStageNode()
        .then(() => {
          setDataById().then(() => {
            setRefreshLog(true)
            if (setRefreshStatus) {
              setRefreshStatus(true)
            }
            fetchTbData()
            setProcessNodes(updLoading(index, false))
            setIsRefreshNode(true)
            showNotification({
              title: '操作成功',
            })
          })
        })
        .catch(() => {
          setProcessNodes(updLoading(index, false))
        })
    }
  }
  const toStartFlow = () => {
    setStartFlowLoading(true)
    startFlow().then(() => {
      fetchTbData()
      setShowStartFlow(false)
      setStartFlowLoading(false)
    })
  }
  return (
    <div>
      {isShowStatus ? (
        <StyledStatusContent>
          <IconMaps type="processIcon" width={24} height={24} />
          <span>{data && data.specialUcaseExtStatus}</span>
        </StyledStatusContent>
      ) : (
        <StyledBtnContent>
          {processNodes.map((node, index) => {
            return (
              <Button
                loading={node.loading}
                style={{
                  padding: '5px 16px',
                }}
                onClick={() => {
                  submitNode(node, index)
                }}
                type="primary"
              >
                {node.nodeName}
              </Button>
            )
          })}
        </StyledBtnContent>
      )}
      {isShowStartFlow && allowStartFlow && (
        <div className="flex justify-end">
          <Button
            type="primary"
            style={{ margin: '20px' }}
            onClick={toStartFlow}
            loading={startFlowLoading}
          >
            开启流程
          </Button>
        </div>
      )}
      <FaceRecognition />
    </div>
  )
}

export default Content
